import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import {
  TRAINING_COMPLIANCE_LABELS,
  TRAINING_STATUS_LABELS,
} from '../../utils/training';
import type {
  TrainingComplianceState,
  TrainingStatus,
} from '../../types/training.types';

const COMPLIANCE_STYLES: Record<TrainingComplianceState, string> = {
  green: 'border-teal-200 bg-teal-50 text-teal-800',
  yellow: 'border-amber-200 bg-amber-50 text-amber-800',
  red: 'border-rose-200 bg-rose-50 text-rose-800',
};

const STATUS_STYLES: Record<TrainingStatus, string> = {
  pending: 'border-slate-200 bg-slate-100 text-slate-700',
  in_progress: 'border-blue-200 bg-blue-50 text-blue-800',
  completed: 'border-teal-200 bg-teal-50 text-teal-800',
  locked: 'border-rose-200 bg-rose-50 text-rose-800',
};

export function TrainingComplianceBadge({
  state,
  className,
}: {
  state: TrainingComplianceState;
  className?: string;
}) {
  return (
    <Badge variant="outline" className={cn(COMPLIANCE_STYLES[state], className)}>
      <span
        aria-hidden
        className={cn(
          'mr-1.5 h-1.5 w-1.5 rounded-full',
          state === 'green' && 'bg-teal-500',
          state === 'yellow' && 'bg-amber-500',
          state === 'red' && 'bg-rose-500',
        )}
      />
      {TRAINING_COMPLIANCE_LABELS[state]}
    </Badge>
  );
}

export function TrainingStatusBadge({
  status,
  className,
}: {
  status: TrainingStatus;
  className?: string;
}) {
  return (
    <Badge variant="outline" className={cn(STATUS_STYLES[status], className)}>
      {TRAINING_STATUS_LABELS[status]}
    </Badge>
  );
}
